export default __webpack_public_path__ + "static/media/zincoins.4e4ff6a7.svg";